<template>
	<div class="order-refund">
		<search-refund-record
			v-on:onSubmit="onSubmit"
			v-on:resetSearch="resetSearch"
			:payTypeList="payTypeList"
			:search="search"
		>
		</search-refund-record>
		<div class="vue-padding radius">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="refundRecordList"
				style="width: 100%"
				max-height="638"
				:border="true"
			>
				<el-table-column
					prop="rs"
					:label="$t('orderRefund.state')"
					width="140"
					:align="'center'"
				>
					<template slot-scope="scope">
						<span v-if="scope.row.rs === 1" class="vtm-pill vtm-pill--ok">{{
							$t("orderRefund.success")
						}}</span>
						<span v-else-if="scope.row.rs === -1" class="vtm-pill vtm-pill--crit">{{
							$t("orderRefund.error")
						}}</span>
						<span v-else-if="scope.row.rs === 0" class="vtm-pill vtm-pill--info">Refunding</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="orderNumber"
					:label="$t('orderRefund.orderNumber')"
					width="140"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="payType"
					:label="$t('orderRefund.payType')"
					:formatter="payType"
					width="140"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="price"
					:label="$t('orderRefund.refundPrice')"
					width="140"
					:align="'center'"
					:formatter="(row) => $currency(row.price)"
				></el-table-column>
				<el-table-column
					prop="resultCode"
					:label="$t('orderRefund.backCode')"
					width="140"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="resultInfo"
					:label="$t('orderRefund.backInfo')"
					:show-overflow-tooltip="true"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="createTime"
					:formatter="(row) => $formatDate(row.createTime)"
					:label="$t('orderRefund.createTime')"
					width="160"
					:align="'center'"
				></el-table-column>
			</el-table>
			<el-pagination
				background
				layout="total,sizes,prev, pager, next,jumper"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				:page-size="page.pageSize"
				@size-change="sizeChange"
				@current-change="currentChange"
			></el-pagination>
		</div>
	</div>
</template>

<script>
import searchRefundRecord from "_c/order/SearchRefundRecord";
export default {
	name: "OrderRefund",
	components: {
		searchRefundRecord,
	},
	data() {
		return {
			search: {
				orderNumber: "",
				payType: "",
			},
			loading: false,
			page: {
				pageSize: 10,
				pageIndex: 1,
			},
			refundRecordList: [],
			payTypeList: [],
		};
	},
	mounted() {
		this.listPayType();
		this.currentChange();
	},
	methods: {
		listPayType() {
			this.$api.dict("gp_pay_type").then(res => {
				if (res.code === 0) {
					this.payTypeList = res.data;
				}
			});
		},
		sizeChange(pageSize) {
			this.page.pageSize = pageSize;
			this.currentChange();
		},
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.search, this.page);
			this.$api
				.request(this.$url.RefundRecord.page, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.refundRecordList = res.data.records;
						this.page.totalSize = parseInt(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		payType(row) {
			return this.$cloud.getDictLabel(this.payTypeList, row.payType);
		},
		onSubmit(data) {
			this.search = data;
			this.currentChange();
		},
		resetSearch(data) {
			this.search = data;
			this.currentChange();
		},
	},
};
</script>

<style scoped></style>
